import * as yup from 'yup';

const schema = yup.object().shape({
  codigo: yup.string().min(5).max(90).required(),
});

export default schema;
